import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';
// import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import moment from 'moment';

import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../components';

import { getCoutnryCity, exportUsers } from '../../../redux/actions/emailManagerActions';
import { CSVLink } from "react-csv";

let cityID = [];
let csvData = [];
let isLoading = "false";
class ExportUsers extends Component {
  constructor(props){
    super(props);
    this.state = {
      startDateValue : true,
      startDateRange :  '',
      startDateRangeStatus : false,
      cityList: '',
      cityID: '',
      cityError: false,
      dateError: false,
      path: ['Home', 'Export Users'], 
      links: ["home",'/export/users'],
      allCheck: false,
      fileName: 'Users_' + moment(),
      allCity: 1,
      csvData: '',
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange=this.handleChange.bind(this);
  }

  handleChange(e){
    this.setState({[e.target.name]:e.target.value});
  }

  componentWillMount(){
    isLoading = "true";
    this.props.getCoutnryCity();
  }

  componentWillReceiveProps(nextProps){
    
    if(this.props.cityList !== nextProps.cityList){
        if(nextProps.cityList){
          isLoading = "false";
          this.setState({cityList: nextProps.cityList.data});
        }
    } 

    if(this.props.exportStatus !== nextProps.exportStatus){
      if(nextProps.exportStatus){
          isLoading = "false";
          this.handleExport(nextProps.exportStatus.data);
      }
    }
  }


  handleExport = data => {
    csvData = [
      [
        "#",
        "Email",
        "First Name",
        "Last Name",
        "User Name",
        "DOB",
        "Gender",
        "Phone",
        "Address 1",
        "Address 2",
        "City",
        "State",
        "Country",
        // "Status",
      ]
    ];

    if (data) {
      data.map((list, index) => {
        csvData.push([
          ++index,
          list.email,
          list.firstName,
          list.lastName,
          list.userName,
          list.dob,
          list.gender,
          list.phone,
          list.address1,
          list.address2,
          list.title,
          list.state,
          list.countryName,
          // list.status,
        ]);
      });
    }
    this.setState({ csvData: csvData });
  };



  onChangeStartDateRange = date => {
    this.setState({ startDateRange: date});
    this.setState({dateError: false});
  }

  handleCityData = (e) => {
    cityID = (this.state.cityID) ? this.state.cityID : [];
    let index;

    if (e.target.checked) {
      cityID.push(e.target.value);
    } else {
      index = cityID.indexOf(e.target.value)
      cityID.splice(index, 1)
    }
    this.setState({cityError: false});
    this.setState({cityID : cityID});
  }

  handleAllCheck = (e) => {
    if (e.target.checked) {
      this.setState({allCheck : true, allCity: 0 });
    } else {
      this.setState({allCheck : false, allCity: 1 });
    }
  }


  validate = (e) => {
    let isError = false;
    if(this.state.cityID.length == 0 && this.state.allCity == 1){
      isError = true;
      this.setState({cityError: true});
    }else{
      this.setState({cityError: false});
    }

    if(this.state.startDateRange == '' && this.state.startDateValue == ''){
      isError = true;
      this.setState({dateError: true});
    }else{
      this.setState({dateError: false});
    }

    return isError;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let isError = this.validate();
    let dateRange;
    if(!isError){
      dateRange = (this.state.startDateRange) ? this.state.startDateRange : '';
      const constData = {
        fileName: this.state.fileName,
        allCity: this.state.allCity,
        cityIDs: this.state.cityID,
        dates: (this.state.startDateValue) ? 0 : 1,
        fromDate: (dateRange) ? dateRange[0] : '',
        toDate: (dateRange) ? dateRange[1] : '',
      }
      isLoading = "true";
      this.props.exportUsers(constData);
    }
  }

  handSubscriptionDate = (e) => {
     if (e.target.checked) {
      this.setState({startDateRangeStatus : false, startDateValue: 'all', startDateRange: ''})
     } else {
      this.setState({startDateRangeStatus : true, startDateValue: ''})
     }

     this.setState({dateError: false});
  }

  render() {
    
  return (
    <div className="col-lg-12 add-sub-admin">
    {isLoading == "true" ? (
      <div className="loader">
        <p className="loading-message">
          <i>Loading...</i>
        </p>
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>
    ) : (
      ""
    )}
    <div className="row">
      <div className="col-xs-12">
         <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
      </div>
    </div>
    <form>
      <div className="panel">
          <header className="panel-heading">Export Users</header>
          <div className="panel-body">
          <Row>
              <Col md={12} xs={12}>
                <FormGroup>
                  <Row>
                      <Col md={6} xs={6}>
                        <ControlLabel>File Name:</ControlLabel>
                        <FormControl
                          type="text"
                          placeholder="File Name"
                          defaultValue={this.state.fileName}
                          name="fileName"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.campaignNameError}}
                        />
                      </Col>
                  </Row>
                  <ControlLabel>Users in the following Cities: <span className="text-danger">{(this.state.cityError) ? '(Please select city.)' : ''}</span></ControlLabel>
                  <Row>
                      <Col md={12} xs={12}>
                        <Checkbox value="all" onClick={this.handleAllCheck}>Select All City</Checkbox>
                      </Col>
                  </Row>
                  {(this.state.cityList) &&
                    this.state.cityList.map((data, index) =>
                      <Row key={index}>
                      <Col md={12} xs={12}><b>{(data.cities.length != 0) ? data.country : ''}</b></Col>
                        <Col md={12} xs={12}>
                          <Row>
                          {data.cities.map((cityData, index) => 
                              <Col key={index} md={4} xs={12}>
                                {(cityID.indexOf(JSON.stringify(cityData.cityID)) > -1) ?
                                // <div>check</div>
                                <Checkbox onClick={this.handleCityData} defaultChecked={true} value={cityData.cityID}>{cityData.title}</Checkbox>
                                :
                                <Checkbox onClick={this.handleCityData} checked={this.state.allCheck}  value={cityData.cityID}>{cityData.title}</Checkbox>
                                }
                              </Col>
                            )
                          }
                          </Row>
                        </Col>
                      </Row>
                    )
                  }
                </FormGroup>
              </Col>
              <Col md={12} xs={12}>
                <FormGroup>
                  <ControlLabel>Subscription Date: <span className="text-danger">{(this.state.dateError) ? '(Please select date option.)' : ''}</span></ControlLabel>
                  <Checkbox name="dates" defaultChecked={this.state.startDateValue} onClick={this.handSubscriptionDate}>
                    All Dates
                  </Checkbox>
                  {/* {(this.state.startDateRangeStatus) &&
                  // <DateRangePicker
                  //   onChange={this.onChangeStartDateRange}
                  //   value={this.state.startDateRange}
                  // />
                  } */}
                </FormGroup>
              </Col>
          </Row>
          
          <Row><hr/></Row>
          <Row>
            <Col md={12} xs={12}>
              <Button bsStyle="success" className="pull-right" onClick={this.handleSubmit}>Export List</Button>
              {this.state.csvData ? (
                <CSVLink
                  data={this.state.csvData}
                  filename={this.state.fileName+".csv"}
                  className="btn btn-danger"
                >
                Download Users List
                  </CSVLink>
                ) : null}
            </Col>
          </Row>
          </div>
      </div>
    </form>
    </div>
  )
  }
}

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.emailManagerReducer.error,
      cityList:  state.emailManagerReducer.cityList,
      exportStatus:  state.emailManagerReducer.exportStatus,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {getCoutnryCity, exportUsers})
)(ExportUsers);


// WEBPACK FOOTER //
// ./src/app/views/admin/user/ExportUsers.js